import {useDispatch} from "react-redux";
import {useForm} from "react-hook-form";
import {useActions} from "../../../store/actions";
import {yupResolver} from "@hookform/resolvers/yup";
import {loginAction} from "../../../store/actions/auth";
import {userSignUpRequest} from "../../../services/api";
import {setHasAdminAction} from "../../../store/actions/global";
import {signUpUserFormSchema} from "../../../components/ReactHookForm/schemes";

const useSignUpUserForm = () => {
  const dispatch = useDispatch();
  const login = useActions(loginAction);

  const {handleSubmit, control, trigger, setError} = useForm({
    mode: "onChange",
    resolver: yupResolver(signUpUserFormSchema),
    defaultValues: {
      email: "",
      password: "",
      confirm_password: "",
      service_checkbox: false,
      is_remember_me: false
    }
  });

  const onFormSubmit = ({email, password, is_remember_me}) => {
    userSignUpRequest(email, password)
      .then(() => login(email, password, is_remember_me))
      .then(() => dispatch(setHasAdminAction(true)));
  };

  return {
    onFormSubmit,
    form: {
      control,
      trigger,
      handleSubmit,
      setFormError: setError
    }
  };
};

export default useSignUpUserForm;